import EmptySection from './EmptySection';
import styles from './PhaseProgress.module.css';
import { useTranslation } from 'react-i18next';

const PhaseProgress = ({ phases, onPhaseClick }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.card}>
      <h3 className={styles.title}>Phase Progress</h3>
      {!phases?.length ? (
        <EmptySection />
      ) : (
        <div className={styles.phaseList}>
          {phases.map((phase) => {
            const isDisabled = !phase.prikaz;
            const isClickable = !isDisabled && !!onPhaseClick;
            const iconColor = isDisabled ? '#d1d5db' : phase.boja;

            return (
              <div
                key={phase.id}
                className={`${styles.phaseItem} ${
                  isDisabled ? styles.phaseItemDisabled : ''
                } ${isClickable ? styles.phaseItemClickable : ''}`}
                onClick={isClickable ? () => onPhaseClick(phase) : undefined}
                role={isClickable ? 'button' : undefined}
                tabIndex={isClickable ? 0 : undefined}
                onKeyDown={
                  isClickable
                    ? (e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          onPhaseClick(phase);
                        }
                      }
                    : undefined
                }
              >
                <div
                  className={styles.phaseIcon}
                  style={{ background: iconColor }}
                >
                  <i className={phase.ikonica} />
                </div>

                <span className={styles.phaseName}>
                  {t(`projectPhases.${phase.key}`)}
                </span>

                <div className={styles.phaseBar}>
                  <div
                    className={styles.phaseBarFill}
                    style={{
                      width: `${phase.procenatBar}%`,
                      background:
                        phase.procenat > 0 && phase.prikaz
                          ? phase.boja
                          : '#e5e7eb',
                    }}
                  />
                </div>

                <span className={styles.phasePercent}>{phase.procenat}%</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PhaseProgress;
